<div class="grid grid-cols-1 gap-4 w-full items-stretch lg:grid-cols-2">
  <div
    class="flex flex-col rounded-16 overflow-hidden w-full shadow-card h-full"
  >
    <div class="w-full flex gap-1 py-4 px-5 items-center bg-grey-skeleton">
      <div class="w-5 h-5 rounded-full bg-white animate-pulse"></div>
      <div class="h-5 w-32 bg-white rounded animate-pulse"></div>
    </div>
    <div class="w-full flex flex-col py-4 px-5 gap-3">
      <div class="h-4 w-3/4 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-2/3 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-1/2 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-full bg-grey-skeleton rounded animate-pulse"></div>
    </div>
  </div>

  <div
    class="flex flex-col rounded-16 overflow-hidden w-full shadow-card h-full"
  >
    <div class="w-full flex gap-1 py-4 px-5 items-center bg-grey-skeleton">
      <div class="w-5 h-5 rounded-full bg-white animate-pulse"></div>
      <div class="h-5 w-32 bg-white rounded animate-pulse"></div>
    </div>
    <div class="w-full flex flex-col py-4 px-5 gap-3">
      <div class="h-4 w-3/4 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-2/3 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-1/2 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-3/4 bg-grey-skeleton rounded animate-pulse"></div>
      <div class="h-4 w-full bg-grey-skeleton rounded animate-pulse"></div>
    </div>
  </div>
</div>
